import { getContext } from "@src/client/context";
import getRsftWelcomeMessageAlreadyClosed from "./getRsftWelcomeMessageAlreadyClosed";
import { getDeliveryOptions } from "@src/api/index";
import { getResolvedDeliveryCountry } from "@src/template/state/modules/welcomeMessage/getResolvedDeliveryCountry";
import { getOrSetInLocalStorageWithExpiryAsync } from "@src/helpers/webStorage";
import {
  RSFT_DELIVERY_OPTIONS_CACHE_TTL_MS,
  RSFT_DELIVERY_OPTIONS_LOCAL_STORAGE_PREFIX
} from "@template/constants";

const getUserRsftWelcomeMessageMetadata = async () => {
  const context = getContext();
  const currentBrowseCountry = context.getBrowseCountry();
  const geoCountry = context.getGeoCountry();
  const storeId = context.getStoreId();

  const rsftMessageDismissedThisSession = getRsftWelcomeMessageAlreadyClosed();

  if (geoCountry === currentBrowseCountry || rsftMessageDismissedThisSession) {
    return { show: false };
  }

  let resolvedDeliveryCountry;
  try {
    resolvedDeliveryCountry = await getResolvedDeliveryCountry({
      geoCountry
    });
  } catch (_error) {
    return { show: false };
  }

  if (!resolvedDeliveryCountry) {
    return { show: false };
  }

  let deliveryOptions;
  try {
    deliveryOptions = await getOrSetInLocalStorageWithExpiryAsync(
      {
        cacheKeyPrefix: RSFT_DELIVERY_OPTIONS_LOCAL_STORAGE_PREFIX,
        timeToLiveMs: RSFT_DELIVERY_OPTIONS_CACHE_TTL_MS,
        returnCachedOnDelegateFailure: false,
        removeOtherCacheItems: false,
        localStorageValueDelegate: getDeliveryOptions
      },
      resolvedDeliveryCountry,
      storeId
    );
  } catch (_error) {
    return { show: false };
  }

  const deliveryOptionsAvailable = !!deliveryOptions.countries[0]
    .deliveryMethods.length;

  return {
    show: !deliveryOptionsAvailable,
    resolvedDeliveryCountry
  };
};

export default getUserRsftWelcomeMessageMetadata;
